import { render, staticRenderFns } from "./shippingLabel.vue?vue&type=template&id=8bd2ddae&scoped=true&"
import script from "./shippingLabel.vue?vue&type=script&lang=js&"
export * from "./shippingLabel.vue?vue&type=script&lang=js&"
import style0 from "./shippingLabel.vue?vue&type=style&index=0&id=8bd2ddae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd2ddae",
  null
  
)

export default component.exports